import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import request from '../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../helpers/PlantillaScreen';
import { LoaderScreen } from '../components/LoaderScreen';
import { ButtonBack } from '../PermisosUsuarios/GestioActividades/Util/ButtonBack';
import { MapContainer, TileLayer, Marker, Popup, Polyline, CircleMarker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../../Helpers/leafletIconFix';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, TextField } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import tractorIcon from '../../Styles/imagenes/tractor.png';

const iconoUbicacionMaquina = L.icon({
    iconUrl: tractorIcon,
    iconSize: [42, 42],
    iconAnchor: [21, 21],
    popupAnchor: [0, -21],
});
const esUTCExplicito = (fecha) => /[Zz]|[+-]\d{2}:?\d{2}$/.test(fecha);

const formatearFecha = (fecha) => {
    if (!fecha) return "Sin datos";
    const d = new Date(esUTCExplicito(fecha) ? fecha : `${fecha}Z`);
    if (isNaN(d)) return fecha;
    return d.toLocaleString('es-MX', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
        timeZone: 'America/Mazatlan'
    });
};

const colorCombustible = (pct) => {
    if (pct == null) return '#9e9e9e';
    if (pct <= 20) return '#e53935';
    if (pct <= 50) return '#f9a825';
    return '#367C2B';
};

const claseSeveridad = (severidad) => {
    if (!severidad) return 'cm-badge-default';
    const s = severidad.toLowerCase();
    if (s === 'info') return 'cm-badge-info';
    if (s === 'none') return 'cm-badge-info';
    if (s === 'medium') return 'cm-badge-medium';
    if (s === 'high') return 'cm-badge-high';
    if (s === 'critical') return 'cm-badge-critical';
    if (s === 'low') return 'cm-badge-low';
    return 'cm-badge-default';
}

const fechaHoy = () => {
    const d = new Date();
    return d.toISOString().split('T')[0]; 
};

const aYYYYMMDD = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const primerDiaMesActual = () => {
    const hoy = new Date();
    return aYYYYMMDD(new Date(hoy.getFullYear(), hoy.getMonth(), 1));
};

const ultimoDiaMesActual = () => {
    const hoy = new Date();
    return aYYYYMMDD(new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0));
};

const nombreMesActual = () => {
    const nombre = new Date().toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });
    return nombre.charAt(0).toUpperCase() + nombre.slice(1);
};

const distanciaTotalKm = (puntos) => {
    const radioTierra = 6371; // km
    let total = 0;
    for (let i = 1; i < puntos.length; i++) {
        const [lat1, lon1] = [puntos[i - 1].latitud, puntos[i - 1].longitud];
        const [lat2, lon2] = [puntos[i].latitud, puntos[i].longitud];
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) ** 2;
        total += radioTierra * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }
    return total;
};
const paletaColores = ['#367C2B', '#e53935', '#1976d2', '#f9a825', '#8e24aa', '#00897b', '#d81b60', '#5d4037', '#3949ab', '#c0ca33'];
const colorPorIndice = (i) => paletaColores[i % paletaColores.length];

const agruparPorDia = (puntos) => {
    const grupos = {};
    puntos.forEach((p) => {
        const dia = p.fecha_evento ? p.fecha_evento.substring(0, 10) : 'sin-fecha';
        if (!grupos[dia]) grupos[dia] = [];
        grupos[dia].push(p);
    });
    return Object.entries(grupos).sort(([a], [b]) => a.localeCompare(b));
};

const MESES_ABREV = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
const etiquetaDia = (d) => `${d.getDate()} ${MESES_ABREV[d.getMonth()]}`;

const formatearDuracion = (ms) => {
    if (ms == null || ms <= 0) return '0 min';
    const totalMin = Math.round(ms / 60000);
    const h = Math.floor(totalMin / 60);
    const m = totalMin % 60;
    if (h === 0) return `${m} min`;
    if (m === 0) return `${h} h`;
    return `${h} h ${m} min`;
};
const construirDiasOperacion = (segmentos, desde, hasta) => {
    if (!desde || !hasta || !Array.isArray(segmentos)) return [];

    const inicioRango = new Date(`${desde}T00:00:00`);
    const finRango = new Date(`${hasta}T00:00:00`);
    finRango.setDate(finRango.getDate() + 1);

    const segsCrudos = segmentos
        .map((s) => ({
            inicio: new Date(esUTCExplicito(s.start_date) ? s.start_date : `${s.start_date}Z`),
            fin: new Date(esUTCExplicito(s.end_date) ? s.end_date : `${s.end_date}Z`),
            estado: s.engine_state,
        }))
        .filter((s) => s.fin > s.inicio)
        .sort((a, b) => a.inicio - b.inicio || a.fin - b.fin);

    const segsNormalizados = [];
    segsCrudos.forEach((s) => {
        const anterior = segsNormalizados[segsNormalizados.length - 1];
        if (!anterior || s.inicio >= anterior.fin) {
            segsNormalizados.push({ ...s });
            return;
        }
        if (s.estado === anterior.estado) {
            if (s.fin > anterior.fin) anterior.fin = s.fin;
            return;
        }
        if (s.fin > anterior.fin) {
            segsNormalizados.push({ inicio: anterior.fin, fin: s.fin, estado: s.estado });
        }
    });

    const dias = [];
    for (let d = new Date(inicioRango); d < finRango; d.setDate(d.getDate() + 1)) {
        const inicioDia = new Date(d);
        const finDia = new Date(d);
        finDia.setDate(finDia.getDate() + 1);
        const totalMsDia = finDia - inicioDia;

        const segsDelDia = segsNormalizados
            .map((s) => ({
                inicio: s.inicio < inicioDia ? inicioDia : s.inicio,
                fin: s.fin > finDia ? finDia : s.fin,
                estado: s.estado,
            }))
            .filter((s) => s.fin > s.inicio)
            .sort((a, b) => a.inicio - b.inicio);

        const bloques = [];
        let cursor = inicioDia;
        segsDelDia.forEach((s) => {
            if (s.inicio > cursor) bloques.push({ tipo: 'no_disponible', inicio: cursor, fin: s.inicio });
            bloques.push({ tipo: s.estado === 1 ? 'activado' : 'apagado', inicio: s.inicio, fin: s.fin });
            if (s.fin > cursor) cursor = s.fin;
        });
        if (cursor < finDia) bloques.push({ tipo: 'no_disponible', inicio: cursor, fin: finDia });

        const bloquesPct = bloques.map((b) => ({
            tipo: b.tipo,
            inicioPct: ((b.inicio - inicioDia) / totalMsDia) * 100,
            anchoPct: ((b.fin - b.inicio) / totalMsDia) * 100,
        }));

        const totalActivadoMs = segsDelDia
            .filter((s) => s.estado === 1)
            .reduce((acc, s) => acc + (s.fin - s.inicio), 0);

        dias.push({ fecha: aYYYYMMDD(inicioDia), etiqueta: etiquetaDia(inicioDia), bloques: bloquesPct, totalActivadoMs });
    }

    return dias.reverse();
};

// Diferencia entre la última y la primera lectura no nula de un campo acumulado (ej. horas_idle)
const deltaAcumulado = (lecturas, campo) => {
    if (!Array.isArray(lecturas)) return null;
    const filtradas = lecturas.filter((l) => l[campo] != null);
    if (filtradas.length < 2) return null;
    return filtradas[filtradas.length - 1][campo] - filtradas[0][campo];
};

const ultimosRegistros = (arr, campoFecha, n = 3) => {
    if (!Array.isArray(arr)) return [];
    return [...arr]
        .sort((a, b) => new Date(b[campoFecha]) - new Date(a[campoFecha]))
        .slice(0, n);
};
export const CentroMonitoreoDetalle = () => {

    const { jd_machine_id } = useParams();
    const [data, setData] = useState(null);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // ---- Modal genérico (Alertas) ----
    const [modal, setModal] = useState({
        abierto: false,
        tipo: null,       // 'alertas'
        cargando: false,
        registros: [],
    });

    // ---- Modal de Recorrido ----
    const [recorrido, setRecorrido] = useState({
        abierto: false,
        fecha: fechaHoy(),
        cargando: false,
        puntos: [],
    });

    const [recorridoCompleto, setRecorridoCompleto] = useState({
        abierto: false,
        desde: primerDiaMesActual(),
        hasta: ultimoDiaMesActual(),
        cargando: false,
        puntos: [],
    });
    const [horasMotor, setHorasMotor] = useState({
        abierto: false,
        desde: primerDiaMesActual(),
        hasta: ultimoDiaMesActual(),
        cargando: false,
        lecturas: [],
    });

    const [combustible, setCombustible] = useState({
        abierto: false,
        desde: '',
        hasta: '',
        cargando: false,
        lecturas: [],
    });

    const [horasIdle, setHorasIdle] = useState({
        abierto: false,
        desde: primerDiaMesActual(),
        hasta: ultimoDiaMesActual(),
        cargando: false,
        lecturas: [],
    });

    const [horasOperacion, setHorasOperacion] = useState({
        desde: aYYYYMMDD(new Date()),
        hasta: aYYYYMMDD(new Date()),
        cargando: false,
        segmentos: [],
    });

    const [vistaMapa, setVistaMapa] = useState('mapa'); // 'mapa' | 'satelite'
    const [combustibleTotales, setCombustibleTotales] = useState(null);
    const [horasMesActual, setHorasMesActual] = useState([]);
    const [combustibleMesActual, setCombustibleMesActual] = useState([]);

    const [expandirHoras, setExpandirHoras] = useState(false);
    const [expandirCombustible, setExpandirCombustible] = useState(false);
    const [expandirAlertas, setExpandirAlertas] = useState(false);
    const [expandirIdle, setExpandirIdle] = useState(false);

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(`Maquina/Detalle/${jd_machine_id}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("DETALLE MÁQUINA", JSON.stringify(error), "error");
            });

        request
            .get(`Maquina/CombustibleTotales/${jd_machine_id}`)
            .then((result) => {
                setCombustibleTotales(result);
            })
            .catch(() => {
                setCombustibleTotales(null);
            });

        request
            .get(`Maquina/HorasMotorPorRango/${jd_machine_id}?desde=${primerDiaMesActual()}&hasta=${ultimoDiaMesActual()}`)
            .then((result) => {
                setHorasMesActual(result);
            })
            .catch(() => {
                setHorasMesActual([]);
            });

        request
            .get(`Maquina/CombustiblePorRango/${jd_machine_id}?desde=${primerDiaMesActual()}&hasta=${ultimoDiaMesActual()}`)
            .then((result) => {
                setCombustibleMesActual(result);
            })
            .catch(() => {
                setCombustibleMesActual([]);
            });

        cargarHorasOperacion(horasOperacion.desde, horasOperacion.hasta);

    }, [jd_machine_id]);

    const cargarHorasOperacion = (desde, hasta) => {
        setHorasOperacion((prev) => ({ ...prev, cargando: true }));

        const params = new URLSearchParams();
        if (desde) params.append('desde', desde);
        if (hasta) params.append('hasta', hasta);

        request
            .get(`Maquina/HorasOperacionPorRango/${jd_machine_id}?${params.toString()}`)
            .then((result) => {
                setHorasOperacion((prev) => ({ ...prev, cargando: false, segmentos: result }));
            })
            .catch((error) => {
                setHorasOperacion((prev) => ({ ...prev, cargando: false, segmentos: [] }));
                Swal.fire("HORAS DE FUNCIONAMIENTO", JSON.stringify(error), "error");
            });
    };

    const cambiarFiltroHorasOperacion = (campo, valor) => {
        const nuevo = { ...horasOperacion, [campo]: valor };
        setHorasOperacion(nuevo);
        cargarHorasOperacion(nuevo.desde, nuevo.hasta);
    };

    const limpiarFiltroHorasOperacion = () => {
        const hoy = aYYYYMMDD(new Date());
        setHorasOperacion((prev) => ({ ...prev, desde: hoy, hasta: hoy }));
        cargarHorasOperacion(hoy, hoy);
    };

    const abrirModal = (tipo) => {
        setExpandirAlertas(false);
        setModal({ abierto: true, tipo, cargando: true, registros: [] });

        request
            .get(`Maquina/AlertasPorMaquina/${jd_machine_id}`)
            .then((result) => {
                setModal((prev) => ({ ...prev, cargando: false, registros: result }));
            })
            .catch((error) => {
                setModal((prev) => ({ ...prev, cargando: false }));
                Swal.fire("HISTÓRICO DE ALERTAS", JSON.stringify(error), "error");
            });
    };

    const cerrarModal = () => {
        setModal({ abierto: false, tipo: null, cargando: false, registros: [] });
    };

    // ---- Funciones de Recorrido ----
    const cargarRecorrido = (fecha) => {
        setRecorrido((prev) => ({ ...prev, cargando: true }));

        request
            .get(`Maquina/RecorridoPorFecha/${jd_machine_id}?fecha=${fecha}`)
            .then((result) => {
                setRecorrido((prev) => ({ ...prev, cargando: false, puntos: result }));
            })
            .catch((error) => {
                setRecorrido((prev) => ({ ...prev, cargando: false, puntos: [] }));
                Swal.fire("RECORRIDO DE MÁQUINA", JSON.stringify(error), "error");
            });
    };

    const abrirRecorrido = () => {
        setRecorrido((prev) => ({ ...prev, abierto: true }));
        cargarRecorrido(recorrido.fecha);
    };

    const cambiarFechaRecorrido = (e) => {
        const nuevaFecha = e.target.value;
        setRecorrido((prev) => ({ ...prev, fecha: nuevaFecha }));
        cargarRecorrido(nuevaFecha);
    };

    const cerrarRecorrido = () => {
        setRecorrido((prev) => ({ ...prev, abierto: false }));
    };


    const cargarHorasMotor = (desde, hasta) => {
        setHorasMotor((prev) => ({ ...prev, cargando: true }));

        const params = new URLSearchParams();
        if (desde) params.append('desde', desde);
        if (hasta) params.append('hasta', hasta);

        request
            .get(`Maquina/HorasMotorPorRango/${jd_machine_id}?${params.toString()}`)
            .then((result) => {
                setHorasMotor((prev) => ({ ...prev, cargando: false, lecturas: result }));
            })
            .catch((error) => {
                setHorasMotor((prev) => ({ ...prev, cargando: false, lecturas: [] }));
                Swal.fire("HORAS DE MOTOR", JSON.stringify(error), "error");
            });
    };

    const abrirHorasMotor = () => {
        setExpandirHoras(false);
        setHorasMotor((prev) => ({ ...prev, abierto: true }));
        cargarHorasMotor(horasMotor.desde, horasMotor.hasta);
    };

    const cambiarFiltroHorasMotor = (campo, valor) => {
        const nuevo = { ...horasMotor, [campo]: valor };
        setHorasMotor(nuevo);
        cargarHorasMotor(nuevo.desde, nuevo.hasta);
    };

    const limpiarFiltroHorasMotor = () => {
        setHorasMotor((prev) => ({ ...prev, desde: '', hasta: '' }));
        cargarHorasMotor('', '');
    };

    const cerrarHorasMotor = () => {
        setHorasMotor((prev) => ({ ...prev, abierto: false }));
    };


    const cargarCombustible = (desde, hasta) => {
        setCombustible((prev) => ({ ...prev, cargando: true }));

        const params = new URLSearchParams();
        if (desde) params.append('desde', desde);
        if (hasta) params.append('hasta', hasta);

        request
            .get(`Maquina/CombustiblePorRango/${jd_machine_id}?${params.toString()}`)
            .then((result) => {
                setCombustible((prev) => ({ ...prev, cargando: false, lecturas: result }));
            })
            .catch((error) => {
                setCombustible((prev) => ({ ...prev, cargando: false, lecturas: [] }));
                Swal.fire("NIVEL DE COMBUSTIBLE", JSON.stringify(error), "error");
            });
    };

    const abrirCombustible = () => {
        setExpandirCombustible(false);
        setCombustible((prev) => ({ ...prev, abierto: true }));
        cargarCombustible(combustible.desde, combustible.hasta);
    };

    const cambiarFiltroCombustible = (campo, valor) => {
        const nuevo = { ...combustible, [campo]: valor };
        setCombustible(nuevo);
        cargarCombustible(nuevo.desde, nuevo.hasta);
    };

    const limpiarFiltroCombustible = () => {
        setCombustible((prev) => ({ ...prev, desde: '', hasta: '' }));
        cargarCombustible('', '');
    };

    const cerrarCombustible = () => {
        setCombustible((prev) => ({ ...prev, abierto: false }));
    };


    const cargarHorasIdle = (desde, hasta) => {
        setHorasIdle((prev) => ({ ...prev, cargando: true }));

        const params = new URLSearchParams();
        if (desde) params.append('desde', desde);
        if (hasta) params.append('hasta', hasta);

        request
            .get(`Maquina/CombustiblePorRango/${jd_machine_id}?${params.toString()}`)
            .then((result) => {
                setHorasIdle((prev) => ({ ...prev, cargando: false, lecturas: result }));
            })
            .catch((error) => {
                setHorasIdle((prev) => ({ ...prev, cargando: false, lecturas: [] }));
                Swal.fire("MOTOR ENCENDIDO SIN MOVIMIENTO", JSON.stringify(error), "error");
            });
    };

    const abrirHorasIdle = () => {
        setExpandirIdle(false);
        setHorasIdle((prev) => ({ ...prev, abierto: true }));
        cargarHorasIdle(horasIdle.desde, horasIdle.hasta);
    };

    const cambiarFiltroHorasIdle = (campo, valor) => {
        const nuevo = { ...horasIdle, [campo]: valor };
        setHorasIdle(nuevo);
        cargarHorasIdle(nuevo.desde, nuevo.hasta);
    };

    const limpiarFiltroHorasIdle = () => {
        setHorasIdle((prev) => ({ ...prev, desde: '', hasta: '' }));
        cargarHorasIdle('', '');
    };

    const cerrarHorasIdle = () => {
        setHorasIdle((prev) => ({ ...prev, abierto: false }));
    };


    const cargarRecorridoCompleto = (desde, hasta) => {
    setRecorridoCompleto((prev) => ({ ...prev, cargando: true }));

    const params = new URLSearchParams();
    if (desde) params.append('desde', desde);
    if (hasta) params.append('hasta', hasta);

    request
        .get(`Maquina/RecorridoPorRango/${jd_machine_id}?${params.toString()}`)
        .then((result) => {
            setRecorridoCompleto((prev) => ({ ...prev, cargando: false, puntos: result }));
        })
        .catch((error) => {
            setRecorridoCompleto((prev) => ({ ...prev, cargando: false, puntos: [] }));
            Swal.fire("RECORRIDO COMPLETO", JSON.stringify(error), "error");
        });
};

    const abrirRecorridoCompleto = () => {
        setRecorridoCompleto((prev) => ({ ...prev, abierto: true }));
        cargarRecorridoCompleto(recorridoCompleto.desde, recorridoCompleto.hasta);
    };

    const cambiarFiltroRecorridoCompleto = (campo, valor) => {
        const nuevo = { ...recorridoCompleto, [campo]: valor };
        setRecorridoCompleto(nuevo);
        cargarRecorridoCompleto(nuevo.desde, nuevo.hasta);
    };

    const limpiarFiltroRecorridoCompleto = () => {
        setRecorridoCompleto((prev) => ({ ...prev, desde: '', hasta: '' }));
        cargarRecorridoCompleto('', '');
    };

    const cerrarRecorridoCompleto = () => {
        setRecorridoCompleto((prev) => ({ ...prev, abierto: false }));
    };
    const tieneUbicacion = data && data.latitud != null && data.longitud != null;

    const horasTrabajadasPeriodo = horasMotor.lecturas.length > 1
        ? horasMotor.lecturas[horasMotor.lecturas.length - 1].horas - horasMotor.lecturas[0].horas
        : null;

    const horasTrabajadasMesActual = horasMesActual.length > 1
        ? horasMesActual[horasMesActual.length - 1].horas - horasMesActual[0].horas
        : null;

    const horasIdleMesActual = deltaAcumulado(combustibleMesActual, 'horas_idle');
    const horasIdleTrabajadasPeriodo = deltaAcumulado(horasIdle.lecturas, 'horas_idle');

    const diasOperacion = construirDiasOperacion(horasOperacion.segmentos, horasOperacion.desde, horasOperacion.hasta);
    const totalActivadoPeriodo = diasOperacion.reduce((acc, d) => acc + d.totalActivadoMs, 0);

    const unidadCombustibleMes = combustibleTotales?.unidad_combustible ?? 'litre';
    const datosResumenMes = [
        { nombre: 'Horas trabajadas', valor: horasTrabajadasMesActual ?? 0, unidad: 'hrs' },
        { nombre: 'Horas ralentì', valor: horasIdleMesActual ?? 0, unidad: 'hrs' },
        { nombre: 'Combustible consumido', valor: combustibleTotales?.total_mes_actual ?? 0, unidad: unidadCombustibleMes },
    ];

    return (
        <PlantillaScreen
            titulo={"CENTRO DE MONITOREO - DETALLE DE MÁQUINA"}
            className_main={1}
            className={"centro-monitoreo-contenedor"}
        >
            <LoaderScreen loader={loader} />

            {data && (
                <div className='cm-contenido scroll'>

                    <div className='cm-detalle-header'>
                        <h2>{data.nombre}</h2>
                        <p>Modelo: {data.modelo} — Núm. Serie: {data.numero_serie}</p>
                    </div>

                    <div className='cm-detalle-layout'>

                        <div className='cm-detalle-grid'>

                            <div
                                className='cm-detalle-card cm-card-clickable'
                                onClick={abrirHorasMotor}
                            >
                                <h3>Horas de Motor</h3>
                                <p><strong>Horas:</strong> {data.horas ?? "Sin datos"}</p>
                                <p><strong>Fecha lectura:</strong> {data.fecha_lectura ? formatearFecha(data.fecha_lectura) : "Sin datos"}</p>
                                <p><strong>Horas trabajadas ({nombreMesActual()}):</strong> {horasTrabajadasMesActual != null ? `${horasTrabajadasMesActual.toFixed(2)} hrs` : "Sin datos"}</p>
                            </div>

                            <div
                                className='cm-detalle-card cm-card-clickable'
                                onClick={abrirCombustible}
                            >
                                <h3>Nivel de Combustible</h3>
                                {data.combustible_pct != null && (
                                    <>
                                        <div className='cm-combustible-barra'>
                                            <div
                                                className='cm-combustible-barra__fill'
                                                style={{
                                                    width: `${Math.min(Math.max(data.combustible_pct, 0), 100)}%`,
                                                    backgroundColor: colorCombustible(data.combustible_pct),
                                                }}
                                            />
                                        </div>
                                        <p className='cm-combustible-porcentaje' style={{ color: colorCombustible(data.combustible_pct) }}>
                                            {data.combustible_pct}%
                                        </p>
                                    </>
                                )}
                                {data.combustible_fecha_lectura && (
                                    <p><strong>Fecha lectura:</strong> {formatearFecha(data.combustible_fecha_lectura)}</p>
                                )}

                                {combustibleTotales && (combustibleTotales.total_historico != null || combustibleTotales.total_mes_actual != null) && (
                                    <div className='cm-combustible-totales'>
                                        {combustibleTotales.total_historico != null && (
                                            <p>
                                                <strong>Total histórico:</strong>{' '}
                                                {combustibleTotales.total_historico.toFixed(2)} {combustibleTotales.unidad_combustible ?? ''}
                                            </p>
                                        )}
                                        {combustibleTotales.total_mes_actual != null && (
                                            <p>
                                                <strong>Este mes:</strong>{' '}
                                                {combustibleTotales.total_mes_actual.toFixed(2)} {combustibleTotales.unidad_combustible ?? ''}
                                            </p>
                                        )}
                                    </div>
                                )}

                                {data.combustible_pct == null && !data.combustible_fecha_lectura && !combustibleTotales?.total_historico && !combustibleTotales?.total_mes_actual && (
                                    <div className='cm-sin-odometro'>
                                        <SpeedOutlinedIcon />
                                        <p>Este equipo no cuenta con odómetro habilitado</p>
                                    </div>
                                )}
                            </div>

                            <div
                                className='cm-detalle-card cm-card-clickable'
                                onClick={() => abrirModal('alertas')}
                            >
                                <h3>Alertas</h3>
                                <p><strong>Total:</strong> {data.total_alertas ?? 0}</p>
                                <p><strong>Última severidad:</strong> {data.ultima_severidad ?? "Sin datos"}</p>
                                <p><strong>Fecha última alerta:</strong> {data.ultima_fecha_alerta ? formatearFecha(data.ultima_fecha_alerta) : "Sin datos"}</p>
                            </div>

                            <div
                                className='cm-detalle-card cm-card-clickable'
                                onClick={abrirHorasIdle}
                            >
                                <h3>Motor Encendido Sin Movimiento</h3>
                                <p><strong>Horas:</strong> {data.combustible_horas_idle ?? "Sin datos"}</p>
                                <p><strong>Fecha lectura:</strong> {data.combustible_fecha_lectura ? formatearFecha(data.combustible_fecha_lectura) : "Sin datos"}</p>
                                <p><strong>Horas ralentì ({nombreMesActual()}):</strong> {horasIdleMesActual != null ? `${horasIdleMesActual.toFixed(2)} hrs` : "Sin datos"}</p>
                            </div>

                            <div className='cm-detalle-card cm-detalle-card--resumen'>
                                <h3>Resumen del Mes ({nombreMesActual()})</h3>
                                <div className='cm-resumen-stats'>
                                    {datosResumenMes.map((item) => (
                                        <div className='cm-resumen-stat' key={item.nombre}>
                                            <span className='cm-resumen-stat__valor'>{item.valor.toFixed(2)}</span>
                                            <span className='cm-resumen-stat__unidad'>{item.unidad}</span>
                                            <span className='cm-resumen-stat__label'>{item.nombre}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>

                        <div className='cm-detalle-card cm-mapa-card'>
                            <div className='cm-mapa-header'>
                                <h3>Última Ubicación</h3>
                                <Button className='cm-btn cm-btn--primary' onClick={abrirRecorrido}>
                                    Recorrido por Día
                                </Button>
                                <Button className='cm-btn cm-btn--primary' onClick={abrirRecorridoCompleto}>
                                    Ver Todos los Recorridos
                                </Button>
                            </div>

                            {tieneUbicacion ? (
                                <>
                                    <div className='cm-mapa-container'>
                                        <button
                                            type='button'
                                            className='cm-mapa-toggle-vista'
                                            onClick={() => setVistaMapa((v) => (v === 'mapa' ? 'satelite' : 'mapa'))}
                                        >
                                            {vistaMapa === 'mapa' ? 'Satélite' : 'Mapa'}
                                        </button>
                                        <MapContainer
                                            center={[data.latitud, data.longitud]}
                                            zoom={15}
                                            scrollWheelZoom={true}
                                            style={{ height: '379px', width: '100%' }}
                                        >
                                            <TileLayer
                                                attribution={vistaMapa === 'satelite'
                                                    ? 'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics'
                                                    : '&copy; OpenStreetMap contributors'}
                                                url={vistaMapa === 'satelite'
                                                    ? 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                                                    : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'}
                                            />
                                            <Marker position={[data.latitud, data.longitud]} icon={iconoUbicacionMaquina}>
                                                <Popup>
                                                    <strong>{data.nombre}</strong><br />
                                                    {formatearFecha(data.fecha_ubicacion)}
                                                </Popup>
                                            </Marker>
                                        </MapContainer>
                                    </div>
                                    <p><strong>Latitud:</strong> {data.latitud} — <strong>Longitud:</strong> {data.longitud}</p>
                                    <p><strong>Fecha:</strong> {formatearFecha(data.fecha_ubicacion)}</p>
                                </>
                            ) : (
                                <p>Sin datos de ubicación</p>
                            )}
                        </div>

                    </div>

                    <div className='cm-detalle-card cm-operacion-card'>
                        <div className='cm-operacion-header'>
                            <h3>Horas de Funcionamiento</h3>
                            <span className='cm-horas-total-badge'>
                                {totalActivadoPeriodo > 0 ? formatearDuracion(totalActivadoPeriodo) : 'Sin datos'}
                            </span>
                        </div>

                        <div className='cm-recorrido-filtros'>
                            <TextField
                                type="date"
                                size="small"
                                label="Desde"
                                value={horasOperacion.desde}
                                onChange={(e) => cambiarFiltroHorasOperacion('desde', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                type="date"
                                size="small"
                                label="Hasta"
                                value={horasOperacion.hasta}
                                onChange={(e) => cambiarFiltroHorasOperacion('hasta', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                            <Button className='cm-btn cm-btn--primary' onClick={limpiarFiltroHorasOperacion}>
                                Limpiar filtro
                            </Button>
                        </div>

                        {horasOperacion.cargando ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                                <CircularProgress />
                            </div>
                        ) : diasOperacion.length === 0 ? (
                            <p style={{ textAlign: 'center', padding: '20px' }}>
                                No se encontraron registros de operación en este periodo
                            </p>
                        ) : (
                            <div className='cm-operacion-timeline'>
                                <div className='cm-operacion-regla'>
                                    <span></span>
                                    <div className='cm-operacion-regla__horas'>
                                        {[0, 3, 6, 9, 12, 15, 18, 21, 24].map((h) => (
                                            <span key={h}>{String(h).padStart(2, '0')}</span>
                                        ))}
                                    </div>
                                    <span></span>
                                </div>

                                {diasOperacion.map((dia) => (
                                    <div className='cm-operacion-fila' key={dia.fecha}>
                                        <span className='cm-operacion-fila__fecha'>{dia.etiqueta}</span>
                                        <div className='cm-operacion-fila__pista'>
                                            {dia.bloques.map((b, i) => (
                                                <div
                                                    key={i}
                                                    className={`cm-operacion-bloque cm-operacion-bloque--${b.tipo}`}
                                                    style={{ left: `${b.inicioPct}%`, width: `${b.anchoPct}%` }}
                                                />
                                            ))}
                                        </div>
                                        <span className='cm-operacion-fila__total'>{formatearDuracion(dia.totalActivadoMs)}</span>
                                    </div>
                                ))}

                                <div className='cm-operacion-leyenda'>
                                    <span><i className='cm-operacion-bloque cm-operacion-bloque--activado'></i> Activado</span>
                                    <span><i className='cm-operacion-bloque cm-operacion-bloque--apagado'></i> Apag.</span>
                                    <span><i className='cm-operacion-bloque cm-operacion-bloque--no_disponible'></i> No disponible</span>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            )}

            <ButtonBack path={`/CentroMonitoreo/Maquinas/${data?.jd_org_id ?? ''}`} ></ButtonBack>

            <Dialog
                open={modal.abierto}
                onClose={cerrarModal}
                maxWidth="md"
                fullWidth
                className='cm-modal'
            >
                <DialogTitle>Histórico de Alertas</DialogTitle>

                <DialogContent dividers>
                    {modal.cargando ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        (() => {
                            const filasAlertas = expandirAlertas
                                ? modal.registros
                                : ultimosRegistros(modal.registros, 'fecha_evento', 3);

                            return (
                                <>
                                    <div className='cm-tabla cm-tabla-modal scroll'>
                                        <table className='cmt-container'>
                                            <thead>
                                                <tr>
                                                    <th>SEVERIDAD</th>
                                                    <th>CÓDIGO DTC</th>
                                                    <th>DESCRIPCIÓN</th>
                                                    <th>FECHA EVENTO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filasAlertas.map((r) => (
                                                    <tr key={r.jd_alert_id}>
                                                        <td>
                                                            <span className={`cm-badge ${claseSeveridad(r.severidad)}`}>
                                                                {r.severidad ?? "N/A"}
                                                            </span>
                                                        </td>
                                                        <td>{r.codigo_dtc ?? "Sin datos"}</td>
                                                        <td>
                                                            {r.descripcion && r.descripcion !== '-' ? r.descripcion : "Sin datos especificos"}
                                                        </td>
                                                        <td className='cm-fecha'>{formatearFecha(r.fecha_evento)}</td>
                                                    </tr>
                                                ))}

                                                {modal.registros.length === 0 && (
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                                                            No se encontraron registros
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {modal.registros.length > 3 && (
                                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                            <Button className='cm-btn cm-btn--primary' onClick={() => setExpandirAlertas((e) => !e)}>
                                                {expandirAlertas ? 'Ver menos' : `Ver todos (${modal.registros.length})`}
                                            </Button>
                                        </div>
                                    )}
                                </>
                            );
                        })()
                    )}
                </DialogContent>

                <DialogActions>
                    <Button className='cm-btn cm-btn--primary' onClick={cerrarModal}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={recorrido.abierto}
                onClose={cerrarRecorrido}
                maxWidth="md"
                fullWidth
                className='cm-modal'
            >
                <DialogTitle>Recorrido del Día</DialogTitle>

                <DialogContent dividers>

                    <div className='cm-recorrido-fecha'>
                        <TextField
                            type="date"
                            size="small"
                            label="Fecha"
                            value={recorrido.fecha}
                            onChange={cambiarFechaRecorrido}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    {recorrido.cargando ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                            <CircularProgress />
                        </div>
                    ) : recorrido.puntos.length === 0 ? (
                        <p style={{ textAlign: 'center', padding: '20px' }}>
                            No se encontraron registros de ubicación para esta fecha
                        </p>
                    ) : (
                        <div className='cm-recorrido-mapa'>
                            <MapContainer
                                bounds={recorrido.puntos.map((p) => [p.latitud, p.longitud])}
                                boundsOptions={{ padding: [50, 50], maxZoom: 17 }}
                                scrollWheelZoom={true}
                                style={{ height: '400px', width: '100%' }}
                            >
                                <TileLayer
                                    attribution='&copy; OpenStreetMap contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />

                                <Polyline
                                    positions={recorrido.puntos.map((p) => [p.latitud, p.longitud])}
                                    pathOptions={{ color: '#367C2B', weight: 4 }}
                                />

                                {/* Puntos intermedios */}
                                {recorrido.puntos.slice(1, -1).map((p, i) => (
                                    <CircleMarker
                                        key={i}
                                        center={[p.latitud, p.longitud]}
                                        radius={4}
                                        pathOptions={{ color: '#367C2B', fillColor: '#8bc34a', fillOpacity: 1, weight: 1 }}
                                    >
                                        <Popup>{formatearFecha(p.fecha_evento)}</Popup>
                                    </CircleMarker>
                                ))}

                                <CircleMarker
                                    center={[recorrido.puntos[0].latitud, recorrido.puntos[0].longitud]}
                                    radius={8}
                                    pathOptions={{ color: '#2e7d32', fillColor: '#4caf50', fillOpacity: 1 }}
                                >
                                    <Popup>
                                        <strong>Inicio</strong><br />
                                        {formatearFecha(recorrido.puntos[0].fecha_evento)}
                                    </Popup>
                                </CircleMarker>

                                <CircleMarker
                                    center={[
                                        recorrido.puntos[recorrido.puntos.length - 1].latitud,
                                        recorrido.puntos[recorrido.puntos.length - 1].longitud,
                                    ]}
                                    radius={8}
                                    pathOptions={{ color: '#b71c1c', fillColor: '#e53935', fillOpacity: 1 }}
                                >
                                    <Popup>
                                        <strong>Fin</strong><br />
                                        {formatearFecha(recorrido.puntos[recorrido.puntos.length - 1].fecha_evento)}
                                    </Popup>
                                </CircleMarker>
                            </MapContainer>

                            <p className='cm-recorrido-total'>
                                Total de puntos registrados: {recorrido.puntos.length}
                                {' - '}
                                Distancia recorrida: {distanciaTotalKm(recorrido.puntos).toFixed(2)} km
                            </p>
                        </div>
                    )}

                </DialogContent>

                <DialogActions>
                    <Button className='cm-btn cm-btn--primary' onClick={cerrarRecorrido}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            <Dialog
            open={recorridoCompleto.abierto}
            onClose={cerrarRecorridoCompleto}
            maxWidth="md"
            fullWidth
            className='cm-modal'
        >
            <DialogTitle>Recorrido Completo</DialogTitle>

            <DialogContent dividers>

                <div className='cm-recorrido-filtros'>
                    <TextField
                        type="date"
                        size="small"
                        label="Desde"
                        value={recorridoCompleto.desde}
                        onChange={(e) => cambiarFiltroRecorridoCompleto('desde', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        type="date"
                        size="small"
                        label="Hasta"
                        value={recorridoCompleto.hasta}
                        onChange={(e) => cambiarFiltroRecorridoCompleto('hasta', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Button className='cm-btn cm-btn--primary' onClick={limpiarFiltroRecorridoCompleto}>
                        Limpiar filtro
                    </Button>
                </div>

                {recorridoCompleto.cargando ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                        <CircularProgress />
                    </div>
                ) : recorridoCompleto.puntos.length === 0 ? (
                    <p style={{ textAlign: 'center', padding: '20px' }}>
                        No se encontraron registros de ubicación
                    </p>
                ) : (
                    (() => {
                        const grupos = agruparPorDia(recorridoCompleto.puntos);
                        return (
                            <>
                                <div className='cm-recorrido-mapa'>
                                    <MapContainer
                                        bounds={recorridoCompleto.puntos.map((p) => [p.latitud, p.longitud])}
                                        boundsOptions={{ padding: [50, 50], maxZoom: 17 }}
                                        scrollWheelZoom={true}
                                        style={{ height: '450px', width: '100%' }}
                                    >
                                        <TileLayer
                                            attribution='&copy; OpenStreetMap contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />

                                        {grupos.map(([dia, puntosDia], i) => (
                                            <Polyline
                                                key={dia}
                                                positions={puntosDia.map((p) => [p.latitud, p.longitud])}
                                                pathOptions={{ color: colorPorIndice(i), weight: 4 }}
                                            />
                                        ))}
                                    </MapContainer>
                                </div>

                                <div className='cm-recorrido-leyenda'>
                                    {grupos.map(([dia, puntosDia], i) => (
                                        <span key={dia} className='cm-leyenda-item'>
                                            <span className='cm-leyenda-color' style={{ backgroundColor: colorPorIndice(i) }}></span>
                                            {dia} ({puntosDia.length} pts)
                                        </span>
                                    ))}
                                </div>

                                <p className='cm-recorrido-total'>
                                    Total de días: {grupos.length} — Total de puntos: {recorridoCompleto.puntos.length}
                                </p>
                            </>
                        );
                    })()
                )}

            </DialogContent>

            <DialogActions>
                <Button className='cm-btn cm-btn--primary' onClick={cerrarRecorridoCompleto}>Cerrar</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={horasMotor.abierto}
            onClose={cerrarHorasMotor}
            maxWidth="md"
            fullWidth
            className='cm-modal'
        >
            <DialogTitle className='cm-dialog-title-flex'>
                <span>Histórico de Horas de Motor</span>
                {horasTrabajadasPeriodo != null && (
                    <span className='cm-horas-total-badge'>
                        Horas trabajadas: {horasTrabajadasPeriodo.toFixed(2)} hrs
                    </span>
                )}
            </DialogTitle>

            <DialogContent dividers>

                <div className='cm-recorrido-filtros'>
                    <TextField
                        type="date"
                        size="small"
                        label="Desde"
                        value={horasMotor.desde}
                        onChange={(e) => cambiarFiltroHorasMotor('desde', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        type="date"
                        size="small"
                        label="Hasta"
                        value={horasMotor.hasta}
                        onChange={(e) => cambiarFiltroHorasMotor('hasta', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Button className='cm-btn cm-btn--primary' onClick={limpiarFiltroHorasMotor}>
                        Limpiar filtro
                    </Button>
                </div>

                {horasMotor.cargando ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                        <CircularProgress />
                    </div>
                ) : horasMotor.lecturas.length === 0 ? (
                    <p style={{ textAlign: 'center', padding: '20px' }}>
                        No se encontraron lecturas de horas de motor
                    </p>
                ) : (
                    (() => {
                        const datosGrafica = horasMotor.lecturas.map((l) => ({
                            fecha: formatearFecha(l.fecha_lectura),
                            horas: l.horas,
                        }));

                        const filasHoras = expandirHoras
                            ? horasMotor.lecturas
                            : ultimosRegistros(horasMotor.lecturas, 'fecha_lectura', 3);

                        return (
                            <>
                                <div style={{ width: '100%', height: 280 }}>
                                    <ResponsiveContainer>
                                        <LineChart data={datosGrafica} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="fecha" tick={{ fontSize: 11 }} />
                                            <YAxis tick={{ fontSize: 11 }} />
                                            <Tooltip />
                                            <Line type="monotone" dataKey="horas" stroke="#367C2B" strokeWidth={2} dot={{ r: 3 }} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className='cm-tabla cm-tabla-modal scroll' style={{ marginTop: '16px' }}>
                                    <table className='cmt-container'>
                                        <thead>
                                            <tr>
                                                <th>FECHA LECTURA</th>
                                                <th>HORAS ACUMULADAS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filasHoras.map((l, i) => (
                                                <tr key={i}>
                                                    <td className='cm-fecha'>{formatearFecha(l.fecha_lectura)}</td>
                                                    <td>{l.horas}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {horasMotor.lecturas.length > 3 && (
                                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                        <Button className='cm-btn cm-btn--primary' onClick={() => setExpandirHoras((e) => !e)}>
                                            {expandirHoras ? 'Ver menos' : `Ver todos (${horasMotor.lecturas.length})`}
                                        </Button>
                                    </div>
                                )}

                                <p className='cm-recorrido-total'>
                                    Total de lecturas: {horasMotor.lecturas.length}
                                    {horasTrabajadasPeriodo != null && (
                                        <>
                                            {' - '}
                                            Horas trabajadas en el periodo: {horasTrabajadasPeriodo.toFixed(2)} hrs
                                        </>
                                    )}
                                </p>
                            </>
                        );
                    })()
                )}

            </DialogContent>

            <DialogActions>
                <Button className='cm-btn cm-btn--primary' onClick={cerrarHorasMotor}>Cerrar</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={combustible.abierto}
            onClose={cerrarCombustible}
            maxWidth="md"
            fullWidth
            className='cm-modal'
        >
            <DialogTitle>Histórico de Nivel de Combustible</DialogTitle>

            <DialogContent dividers>

                <div className='cm-recorrido-filtros'>
                    <TextField
                        type="date"
                        size="small"
                        label="Desde"
                        value={combustible.desde}
                        onChange={(e) => cambiarFiltroCombustible('desde', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        type="date"
                        size="small"
                        label="Hasta"
                        value={combustible.hasta}
                        onChange={(e) => cambiarFiltroCombustible('hasta', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Button className='cm-btn cm-btn--primary' onClick={limpiarFiltroCombustible}>
                        Limpiar filtro
                    </Button>
                </div>

                {combustible.cargando ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                        <CircularProgress />
                    </div>
                ) : combustible.lecturas.length === 0 ? (
                    <p style={{ textAlign: 'center', padding: '20px' }}>
                        No se encontraron lecturas de combustible
                    </p>
                ) : (
                    (() => {
                        const datosGrafica = combustible.lecturas.map((l) => ({
                            fecha: formatearFecha(l.fecha_lectura),
                            combustible: l.combustible_pct,
                        }));

                        const filasCombustible = expandirCombustible
                            ? combustible.lecturas
                            : ultimosRegistros(combustible.lecturas, 'fecha_lectura', 3);

                        return (
                            <>
                                <div style={{ width: '100%', height: 280 }}>
                                    <ResponsiveContainer>
                                        <LineChart data={datosGrafica} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="fecha" tick={{ fontSize: 11 }} />
                                            <YAxis tick={{ fontSize: 11 }} domain={[0, 100]} />
                                            <Tooltip />
                                            <Line type="monotone" dataKey="combustible" stroke="#367C2B" strokeWidth={2} dot={{ r: 3 }} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className='cm-tabla cm-tabla-modal scroll' style={{ marginTop: '16px' }}>
                                    <table className='cmt-container'>
                                        <thead>
                                            <tr>
                                                <th>FECHA LECTURA</th>
                                                <th>COMBUSTIBLE</th>
                                                <th>COMBUSTIBLE CONSUMIDO</th>
                                                <th>HORAS MOTOR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filasCombustible.map((l, i) => (
                                                <tr key={i}>
                                                    <td className='cm-fecha'>{formatearFecha(l.fecha_lectura)}</td>
                                                    <td>{l.combustible_pct != null ? `${l.combustible_pct}%` : "Sin datos"}</td>
                                                    <td>{l.combustible_consumido != null ? `${l.combustible_consumido} ${l.unidad_combustible ?? ''}` : "Sin datos"}</td>
                                                    <td>{l.horas_motor ?? "Sin datos"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {combustible.lecturas.length > 3 && (
                                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                        <Button className='cm-btn cm-btn--primary' onClick={() => setExpandirCombustible((e) => !e)}>
                                            {expandirCombustible ? 'Ver menos' : `Ver todos (${combustible.lecturas.length})`}
                                        </Button>
                                    </div>
                                )}

                                <p className='cm-recorrido-total'>
                                    Total de lecturas: {combustible.lecturas.length}
                                </p>
                            </>
                        );
                    })()
                )}

            </DialogContent>

            <DialogActions>
                <Button className='cm-btn cm-btn--primary' onClick={cerrarCombustible}>Cerrar</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={horasIdle.abierto}
            onClose={cerrarHorasIdle}
            maxWidth="md"
            fullWidth
            className='cm-modal'
        >
            <DialogTitle className='cm-dialog-title-flex'>
                <span>Histórico de Motor Encendido Sin Movimiento</span>
                {horasIdleTrabajadasPeriodo != null && (
                    <span className='cm-horas-total-badge'>
                        Horas ralentì: {horasIdleTrabajadasPeriodo.toFixed(2)} hrs
                    </span>
                )}
            </DialogTitle>

            <DialogContent dividers>

                <div className='cm-recorrido-filtros'>
                    <TextField
                        type="date"
                        size="small"
                        label="Desde"
                        value={horasIdle.desde}
                        onChange={(e) => cambiarFiltroHorasIdle('desde', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        type="date"
                        size="small"
                        label="Hasta"
                        value={horasIdle.hasta}
                        onChange={(e) => cambiarFiltroHorasIdle('hasta', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Button className='cm-btn cm-btn--primary' onClick={limpiarFiltroHorasIdle}>
                        Limpiar filtro
                    </Button>
                </div>

                {horasIdle.cargando ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                        <CircularProgress />
                    </div>
                ) : horasIdle.lecturas.filter((l) => l.horas_idle != null).length === 0 ? (
                    <p style={{ textAlign: 'center', padding: '20px' }}>
                        No se encontraron lecturas de horas ralentì
                    </p>
                ) : (
                    (() => {
                        const lecturasConDato = horasIdle.lecturas.filter((l) => l.horas_idle != null);

                        const datosGrafica = lecturasConDato.map((l) => ({
                            fecha: formatearFecha(l.fecha_lectura),
                            horas_idle: l.horas_idle,
                        }));

                        const filasIdle = expandirIdle
                            ? lecturasConDato
                            : ultimosRegistros(lecturasConDato, 'fecha_lectura', 3);

                        return (
                            <>
                                <div style={{ width: '100%', height: 280 }}>
                                    <ResponsiveContainer>
                                        <LineChart data={datosGrafica} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="fecha" tick={{ fontSize: 11 }} />
                                            <YAxis tick={{ fontSize: 11 }} />
                                            <Tooltip />
                                            <Line type="monotone" dataKey="horas_idle" stroke="#367C2B" strokeWidth={2} dot={{ r: 3 }} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className='cm-tabla cm-tabla-modal scroll' style={{ marginTop: '16px' }}>
                                    <table className='cmt-container'>
                                        <thead>
                                            <tr>
                                                <th>FECHA LECTURA</th>
                                                <th>HORAS RALENTÌ ACUMULADAS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filasIdle.map((l, i) => (
                                                <tr key={i}>
                                                    <td className='cm-fecha'>{formatearFecha(l.fecha_lectura)}</td>
                                                    <td>{l.horas_idle}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {lecturasConDato.length > 3 && (
                                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                        <Button className='cm-btn cm-btn--primary' onClick={() => setExpandirIdle((e) => !e)}>
                                            {expandirIdle ? 'Ver menos' : `Ver todos (${lecturasConDato.length})`}
                                        </Button>
                                    </div>
                                )}

                                <p className='cm-recorrido-total'>
                                    Total de lecturas: {lecturasConDato.length}
                                    {horasIdleTrabajadasPeriodo != null && (
                                        <>
                                            {' - '}
                                            Horas ralentì en el periodo: {horasIdleTrabajadasPeriodo.toFixed(2)} hrs
                                        </>
                                    )}
                                </p>
                            </>
                        );
                    })()
                )}

            </DialogContent>

            <DialogActions>
                <Button className='cm-btn cm-btn--primary' onClick={cerrarHorasIdle}>Cerrar</Button>
            </DialogActions>
        </Dialog>

        </PlantillaScreen>
    )
}